import React from 'react';
import { Box } from '@mui/material';
import { Add as AddIcon, CancelOutlined, Save as SaveIcon } from '@mui/icons-material';

import { FixedFooter } from '@/components/footer/fixed-footer';

export interface PlanActionsButtonProps {
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onAddRow?: () => void;
  cancelLabel?: string;
  submitLabel?: string;
  submittingLabel?: string;
  canUpdate: boolean;
  isPlanDetailPage?: boolean;
}

export const PlanActionsButton: React.FC<PlanActionsButtonProps> = ({
  isSubmitting,
  isSubmitDisabled,
  onCancel,
  onSubmit,
  onAddRow,
  cancelLabel = 'キャンセル',
  submitLabel = '編集内容を決定',
  submittingLabel = '処理中...',
  canUpdate,
  isPlanDetailPage = false,
}) => {
  const buttons = [];

  // Add row button (left side)
  if (onAddRow) {
    buttons.push({
      label: '行を追加',
      onClick: onAddRow,
      variant: 'outlined' as const,
      startIcon: <AddIcon />,
      disabled: isSubmitting || !canUpdate,
      sx: {
        fontWeight: 'bold',
      },
    });
  }

  // Cancel and Submit buttons (right side)
  buttons.push(
    {
      label: cancelLabel,
      onClick: onCancel,
      variant: 'outlined' as const,
      startIcon: <CancelOutlined />,
      disabled: isSubmitting,
      sx: {
        marginLeft: 'auto',
      },
    },
    {
      label: isSubmitting ? submittingLabel : submitLabel,
      onClick: onSubmit,
      variant: 'contained' as const,
      startIcon: <SaveIcon />,
      disabled: isSubmitDisabled || !canUpdate,
      loading: isSubmitting,
    }
  );

  return (
    <>
      {/* Add bottom padding to prevent content from being hidden behind fixed footer */}
      <Box sx={{ height: '100px' }} />
      {/* Fixed Action Footer */}
      <FixedFooter
        buttons={buttons}
        isSubmitting={isSubmitting}
        isPlanPage={true}
        isPlanDetailPage={isPlanDetailPage}
      />
    </>
  );
};
